<template>
  <HKLButtonModal
    color="orange"
    ref="modal"
    okBtnAction="yes"
    :title="$t('tenancy.greenOperation.tips.confirmSubmit')"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { useRefModal } from '@/controls/Modal/modal.hook'
import HKLButtonModal from '@/controls/Modal/HKLButtonModal.vue'

export default {
  components: {
    HKLButtonModal,
  },
  setup () {
    const { modal, open, close } = useRefModal()
    return {
      modal,
      open,
      close,
    }
  },
}
</script>

<style>

</style>
